<div class="bg-gray p-3">
  <div mat-dialog-content>
    <div class="row">
      <div class="col-12">
        <label for="UserType" class="fs-14 fw-normal font-white ms-2">User Type</label>
        <input class="form-control bg-form-control border-0 font-white" [(ngModel)]="UserType" name="UserType" placeholder="User Type" />
      </div>

      <div class="col-12 mt-2">
        <app-navigation-menu [selectedMenu]="MasterMenuList"></app-navigation-menu>
      </div>
    </div>
  </div>

  <div align="end" class="mt-5">
    <button class="btn btn-primary" matRipple (click)="onSubmit()">
      {{ IsEdit ? "Update" : "Submit" }}
    </button>
  </div>
</div>
